export default __webpack_public_path__ + "static/media/(18).31c817d2.jpeg";